import styled from 'styled-components';
import { I18nAndL10n } from './mod';

// biome-ignore lint/suspicious/noShadowRestrictedNames: suppressed due to migration - should be fixed
const Error = styled.span`
	color: #fff;
	position: relative;
	z-index: 0;
	font-size: inherit;

	&::after {
		content: '';
		position: absolute;
		margin: -5px;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		border: 2px solid #790000;
		background: #ff7a7a;
		box-shadow: 0 4px 14px 0 rgb(255 122 122 / 39%);
		z-index: -1;
		border-radius: 4px;
	}
`;

export const withTranslation = (
	translationKey: I18nAndL10n.LocaleKey,
	replaceArguments: { [key: string]: string } | null = null,
): string => {
	// Returns the text alias when running tests
	if (process.env.NODE_ENV === 'test') return translationKey;

	const translation = I18nAndL10n.translate(translationKey, replaceArguments, true);
	if (translation !== '') return translation;

	return (<Error>{translationKey}</Error>) as unknown as string;
};
